import { render } from "./app-proceed-payment-method.vue?vue&type=template&id=6a01eb67&scoped=true"
import script from "./app-proceed-payment-method.vue?vue&type=script&lang=js"
export * from "./app-proceed-payment-method.vue?vue&type=script&lang=js"

import "./app-proceed-payment-method.vue?vue&type=style&index=0&id=6a01eb67&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a01eb67"]])

export default __exports__